module.exports = __webpack_public_path__ + "static/media/04.High and Low pitch Maddale.b75a7840.JPG";